<app-card appVisible [visible$]="visible$">
  <div class="d-flex flex-column justify-content-center align-items-center text-center h-100">
    <h5><i class="bi" [class]="icon"></i>{{ title }}</h5>
    <div class="d-flex">
      @if ((data$ | async) !== undefined && !loading && !error) {
        <div class="container d-flex flex-wrap justify-content-center">
          <span class="value" [style.color]="colorService.getColor(color)">{{ total | appNumber: unit }}</span>
          <span class="unit" [style.color]="colorService.getColor(color)">{{ unit }}</span>
        </div>
      }

      @if (loading) {
        <div class="container placeholder-glow">
          <span class="value col-12">
            <div class="placeholder"></div>
          </span>
        </div>
      }
      @if (error) {
        <app-error-message [error]="error"></app-error-message>
      }
    </div>

    @if (subValues !== undefined && !loading && !error) {
      <div class="sub-values">
        @for (item of subValues; track item.key) {
          <div>
            <span>{{ item.key }}: </span>
            <span>
              <strong>{{ item.value | appNumber: unit }} {{ unit }}</strong>
            </span>
          </div>
        }
      </div>
    }

    <!-- <div class="footer">
      {{ footerText$ | async | appDateRange }}
    </div> -->
  </div>
</app-card>
